<template>
  <h4 v-if="$route.path === '/club/invoice/list'">&nbsp;*<span>{{ $t('message.playerLockProtection') }}</span></h4>
</template>

<script>
export default {
  name: 'NotificationInvoiceLockAsterisk',
}
</script>

<style scoped>
h4 {
  color: #ff7058;
  font-size: 12px;
  font-family: Verdana, sans-serif;
  font-weight: normal;
  display: block;
  -webkit-margin-before: 1.33em;
  -webkit-margin-after: 1.33em;
  -webkit-margin-start: 0;
  -webkit-margin-end: 0;
}

span {
  font-size: 11px;
  color: #999999;
  clear: both;
  padding-top: 10px;
}
</style>

